// Ancient Empires — Tier-B bundle (CLIENT only). Layers images over Tier-A. Generated by create-mod.
// NEVER import from Game.js / server.js / the sim / tests (pulls the keyArt PNG + globe lib).
import { ancientEmpiresData } from './bundle.data';
import { CHARACTERS } from './characters';
import keyArt from '../dominion/keyart.png';
import { getGlobe } from '../dominion/atlas/globe-lib';
import boardBg from './backgrounds/ancient-empires.png';

export const ancientEmpiresClient = Object.assign({}, ancientEmpiresData, {
  characters: CHARACTERS,
  portraits: {},
  keyArt: keyArt,
  atlasAssets: { 'ancient-empires': { worldBg: boardBg, cityImages: {} } },
  getGlobe: getGlobe,
});

export default ancientEmpiresClient;
